module.exports = __webpack_public_path__ + "img/gcdp1_3.588c2eca.jpg";